<template>
	<div v-if="!hideError" id="errorContainer" class="alert alert-danger text-center" :class="{ 'hide': hideError}" role="alert">
		<svgIcon iconHolderClass="icon-warning" iconId="icon-warning"/>
		{{ $t('error.form.' + errorCode, extraErrorData) }}
		<slot/>
	</div>
</template>

<script>
import svgIcon from './icon-svg';

export default {
	name: 'formError',
	introduction: 'Vujs error form component',
	components: {
		svgIcon
	},
	props: {
		hideError: {
			type: Boolean,
			default: true,
			note: 'Show and hide control'
		},
		errorCode: {
			type: String,
			default: '',
			note: 'Set error code to get translated text'
		},
		extraErrorData: {
			type: Object,
			default: () => ({}),
			note: 'Can be set some extra error date'
		}
	},
	computed: {
		formErrorCode() {
			return this.$store.state.form.errors.code;
		},
	},
	watch: {
		formErrorCode() {
			const container = document.getElementById('errorContainer');

			if (this.formErrorCode && container !== null) {
				container.scrollIntoView({
					behavior: 'smooth'
				});
			}
		}
	},
	created() {
		if (!this.formErrorCode) {
			this.hideError = true;
		}
	}
};
</script>

<style lang="less" scoped>
	.alert {
		width: 100%;
	}
	@media (max-width: 740px) {
		.alert {
			margin-bottom: 0;
		}
	}
</style>
